export default __webpack_public_path__ + "static/media/bg-community.fcc5b67a.jpg";